import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setAuthUser } from '../../redux/slice/authSlice';
import { GETRequest, POSTRequest, validateEmail } from '../../utils';
import LoadingButton from '../common/LoadingButton';

const LoginForm = () => {
    const [submitting, setSubmitting] = useState(false);
    const dispatch = useDispatch();
    const [user_roles, setRoles] = useState(null);
    const [error, setError] = useState('');
    const [user, setSignupUser] = useState({
        name: '',
        email: '',
        password: '',
        role_id: '',
    });

    useEffect(() => {
        const getRoles = async () => {
            try {
                const { data } = await GETRequest('roles');
                setRoles(data);
                setSignupUser({ ...user, role_id: data[0].id });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        getRoles();
        // eslint-disable-next-line
    }, []);

    const onSubmit = async () => {
        try {
            if (user.name === '') {
                setError(' مکمل نام درج کریں');
                setTimeout(() => setError(''), 2000);
            } else {
                if (user.email !== '' && validateEmail(user.email)) {
                    if (user.password !== '' && user.password.length >= 8) {
                        if (user.role_id !== '') {
                            setSubmitting(true);
                            const { data, success, message } = await POSTRequest('register', user);
                            if (success) {
                                const {
                                    id,
                                    username,
                                    name,
                                    email,
                                    role,
                                    access_token,
                                    refresh_token,
                                } = data;
                                localStorage.setItem('token', access_token);
                                localStorage.setItem('refresh', refresh_token);
                                dispatch(setAuthUser({ id, username, name, email, role }));
                            } else {
                                throw new Error(message);
                            }
                        } else {
                            setError('براہ کرم صارف کا کردار منتخب کریں');
                            setTimeout(() => setError(''), 3000);
                        }
                    } else {
                        setError('درست پاس ورڈ درج کریں');
                        setTimeout(() => setError(''), 3000);
                    }
                } else {
                    setError('درست امیل درج کریں');
                    setTimeout(() => setError(''), 3000);
                }
            }
        } catch (error) {
            setError('سائن اپ نہیں ہو سکا');
            setTimeout(() => setError(''), 3000);
        }
    };

    return (
        <div className='flex column justifyStart alignCenter w-100' style={{ direction: 'rtl' }}>
            <div className='flex justifyCenter alignCenter w-100'>
                <div className='card form-content'>
                    <div className='flex justifyStart alignCenter card-title'>سائن اپ کریں</div>
                    <div className='card-body'>
                        <div className='form-container'>
                            <label htmlFor='name'>
                                مکمل نام درج کریں
                                <span className='required'>*</span>
                            </label>
                            <input
                                type='text'
                                id='name'
                                className='urdu_field'
                                name='name'
                                value={user.name}
                                autoFocus='on'
                                autoComplete='on'
                                placeholder='قاری احمد رضا'
                                onChange={(event) => {
                                    if (event.target.value.length > 0) {
                                        setSignupUser({ ...user, name: event.target.value });
                                    } else {
                                        setSignupUser({ ...user, name: '' });
                                    }
                                }}
                            />
                        </div>
                        <div className='form-container'>
                            <label htmlFor='email'>
                                امیل درج کریں
                                <span className='required'>*</span>
                            </label>
                            <input
                                type='text'
                                id='email'
                                name='email'
                                value={user.email}
                                autoFocus='on'
                                autoComplete='on'
                                placeholder='abc@gmail.com'
                                onKeyUp={(event) => {
                                    if (event.keyCode === 13) {
                                        setSignupUser({ ...user, email: event.target.value });
                                        onSubmit();
                                    }
                                }}
                                onChange={(event) => {
                                    if (event.target.value.length > 0) {
                                        setSignupUser({ ...user, email: event.target.value });
                                    } else {
                                        setSignupUser({ ...user, email: '' });
                                    }
                                }}
                            />
                        </div>
                        <div className='form-container'>
                            <label htmlFor='password'>
                                پاس ورڈ درج کریں
                                <span className='required'>*</span>
                            </label>
                            <input
                                type='password'
                                id='password'
                                name='password'
                                value={user.password}
                                autoFocus='on'
                                autoComplete='on'
                                placeholder='xxxxxxxx'
                                minLength={8}
                                onKeyUp={(event) => {
                                    if (event.keyCode === 13) {
                                        setSignupUser({ ...user, password: event.target.value });
                                        onSubmit();
                                    }
                                }}
                                onChange={(event) => {
                                    if (event.target.value.length > 0) {
                                        setSignupUser({ ...user, password: event.target.value });
                                    } else {
                                        setSignupUser({ ...user, password: '' });
                                    }
                                }}
                            />
                        </div>
                        {user_roles && (
                            <div className='form-container'>
                                <label htmlFor='role'>
                                    براہ کرم صارف کا کردار منتخب کریں
                                    <span className='required'>*</span>
                                </label>
                                <select
                                    id='role'
                                    name='role'
                                    value={user.role_id}
                                    onSelect={(event) => {
                                        if (event.target.value.length > 0) {
                                            setSignupUser({ ...user, role_id: event.target.value });
                                        } else {
                                            setSignupUser({ ...user, role_id: '' });
                                        }
                                    }}
                                    onChange={(event) => {
                                        if (event.target.value.length > 0) {
                                            setSignupUser({ ...user, role_id: event.target.value });
                                        } else {
                                            setSignupUser({ ...user, role_id: '' });
                                        }
                                    }}
                                >
                                    <option disabled={true}>صارف کا کردار منتخب کریں</option>
                                    {user_roles.map((role, index) => (
                                        <option value={role.id} key={index + 1}>
                                            {role.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                        <div className='form-footer'>
                            <div className='w-100'>
                                <LoadingButton
                                    btnClass='submit-button'
                                    submitting={submitting}
                                    onClick={onSubmit}
                                    label='سائن اپ '
                                    style={{ minWidth: '100%', marginTop: 16 }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {error !== '' && (
                <div
                    className='error-toast w-100'
                    style={{
                        padding: '10px 16px 6px',
                        maxWidth: '50vw',
                        textAlign: 'center',
                        position: 'absolute',
                        bottom: 0,
                    }}
                >
                    <p style={{ color: '#ffffff' }}> {error}</p>
                </div>
            )}
        </div>
    );
};

export default LoginForm;
